module.exports = __webpack_public_path__ + "h5/img/xiao.bfadc33d.jpg";